/* Keep app-owned DOM/listeners and unfinished customer input across cart updates. */
(() => {
 'use strict';
 function replaceMain(current,next){
  if(next.hasAttribute('data-liotro-paused'))current.setAttribute('data-liotro-paused',next.getAttribute('data-liotro-paused'));
  const active=document.activeElement,owned=current.contains(active),line=owned?active.closest('[data-line-key]'):null;
  const focus=line?{key:line.dataset.lineKey,delta:active.dataset.delta,remove:active.dataset.remove}:null;
  for(const selector of ['textarea[name="note"]','#coupon-code']){
   const before=current.querySelector(selector),after=next.querySelector(selector);if(before&&after)after.value=before.value;
  }
  const oldTerms=current.querySelector('[data-liotro-cart-terms]'),newTerms=next.querySelector('[data-liotro-cart-terms]');
  if(oldTerms&&newTerms&&oldTerms.dataset.termsUrl===newTerms.dataset.termsUrl)newTerms.checked=oldTerms.checked;
  for(const selector of ['[data-liotro-cart-app]','[data-liotro-invoice]','[data-liotro-shipping]','[data-liotro-note-host]']){
   const owned=current.querySelector(selector),incoming=next.querySelector(selector);
   if(owned&&incoming)incoming.replaceWith(owned);
  }
  current.replaceChildren(...next.childNodes);
  if(owned){
   let target=active.isConnected?active:null;
   if(!target&&focus){const row=[...current.querySelectorAll('[data-line-key]')].find(e=>e.dataset.lineKey===focus.key);target=[...(row?.querySelectorAll('button')||[])].find(e=>focus.remove?e.dataset.remove===focus.remove:e.dataset.delta===focus.delta);}
   if(!target&&active.matches('textarea[name="note"],#coupon-code'))target=current.querySelector(active.id?'#'+active.id:'textarea[name="note"]');
   target?.focus({preventScroll:true});
  }
 }
 function rememberFocus(element){if(document.activeElement!==element)return null;const row=element.closest('[data-line-key]');return {element,key:row?.dataset.lineKey,delta:element.dataset.delta,remove:element.dataset.remove};}
 function restoreFocus(token){
  if(!token)return;let target=token.element.isConnected?token.element:null;
  if(!target&&token.key){const row=[...document.querySelectorAll('[data-line-key]')].find(e=>e.dataset.lineKey===token.key);target=[...(row?.querySelectorAll('button')||[])].find(e=>token.remove?e.dataset.remove===token.remove:e.dataset.delta===token.delta);if(target?.disabled)target=row?.querySelector('button:not(:disabled)');}
  target?.focus({preventScroll:true});
 }
 window.LiotroCartDOM={replaceMain,rememberFocus,restoreFocus};
})();
